(() => {
  const init = (root) => {
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const input = root.querySelector('[data-fragrance-search]');
    const clearButton = root.querySelector('[data-fragrance-clear]');
    const resetButton = root.querySelector('[data-fragrance-reset]');
    const status = root.querySelector('[data-fragrance-status]');
    const empty = root.querySelector('[data-fragrance-empty]');
    const cards = Array.from(root.querySelectorAll('[data-fragrance-card]'));
    const filters = Array.from(root.querySelectorAll('[data-letter-filter]'));
    let activeLetter = 'all';

    const normalize = (value) => (value || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();

    const setActiveFilter = (letter) => {
      activeLetter = letter;
      filters.forEach((button) => {
        const active = button.dataset.letterFilter === letter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    const applyFilters = () => {
      const term = normalize(input.value);
      input.closest('.jb-fl-search')?.classList.toggle('has-value', Boolean(term));
      let visible = 0;

      cards.forEach((card) => {
        const letterMatch = activeLetter === 'all' || card.dataset.letter === activeLetter;
        const searchMatch = !term || normalize(card.dataset.search).includes(term);
        const show = letterMatch && searchMatch;
        card.hidden = !show;
        if (!show) card.removeAttribute('open');
        if (show) visible += 1;
      });

      empty.hidden = visible !== 0;
      if (visible === 0) status.textContent = 'No fragrances match this search.';
      else if (term && activeLetter !== 'all') status.textContent = `Showing scents beginning with ${activeLetter} that match “${input.value.trim()}”.`;
      else if (term) status.textContent = `Showing scents that match “${input.value.trim()}”.`;
      else if (activeLetter !== 'all') status.textContent = `Showing fragrances beginning with ${activeLetter}.`;
      else status.textContent = 'Explore the complete scent library.';
    };

    filters.forEach((button) => button.addEventListener('click', () => {
      setActiveFilter(button.dataset.letterFilter);
      applyFilters();
    }));

    input?.addEventListener('input', applyFilters);
    input?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        input.value = '';
        setActiveFilter('all');
        applyFilters();
      }
    });

    clearButton?.addEventListener('click', () => {
      input.value = '';
      input.focus();
      applyFilters();
    });

    resetButton?.addEventListener('click', () => {
      input.value = '';
      setActiveFilter('all');
      applyFilters();
      input.focus();
    });

    const revealItems = Array.from(root.querySelectorAll('[data-fragrance-reveal], [data-fragrance-card]'));
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      }, { threshold: .08, rootMargin: '0px 0px -35px' });

      revealItems.forEach((item, index) => {
        if (item.matches('[data-fragrance-card]')) item.style.transitionDelay = `${Math.min(index % 9, 8) * 35}ms`;
        observer.observe(item);
      });
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    const openHashCard = () => {
      const hash = decodeURIComponent(window.location.hash || '').replace('#', '');
      if (!hash || hash === 'fragrance-library') return;
      const card = document.getElementById(hash);
      if (!card || !card.matches('[data-fragrance-card]')) return;

      if (input) input.value = '';
      setActiveFilter('all');
      applyFilters();

      cards.forEach((item) => item.classList.remove('is-hash-target'));
      card.hidden = false;
      card.setAttribute('open', '');
      card.classList.add('is-hash-target');

      window.setTimeout(() => {
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 140);

      window.setTimeout(() => card.classList.remove('is-hash-target'), 2200);
    };

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href*="#"]');
      if (!link) return;
      const url = new URL(link.href, window.location.href);
      if (url.pathname !== window.location.pathname || !url.hash) return;
      window.setTimeout(openHashCard, 0);
    });

    applyFilters();
    openHashCard();
    window.addEventListener('hashchange', openHashCard);
  };

  const boot = () => document.querySelectorAll('[data-fragrance-library]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
